export default function convertDurationToHHMMSS(duration: number | undefined | null) {
  if (!duration) {
    return "N/A";
  }
  var hours = Math.floor(duration / 3600);
  var minutes = Math.floor((duration % 3600) / 60);
  var seconds = duration % 60;

  var formattedHours = hours.toString().padStart(2, "0");
  var formattedMinutes = minutes.toString().padStart(2, "0");
  var formattedSeconds = seconds.toString().padStart(2, "0");

  return formattedHours + ":" + formattedMinutes + ":" + formattedSeconds;
}